<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{
              $route.params.id ? "Edit Benefit Option" : "New Benefit Option"
            }}
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Benefit option reference for employee -->
    <div class="row mb-5">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Benefit Option</th>
                <th v-for="item in benefitItems" :key="item.Id">
                  {{ item.Description }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="benefitOptions.length > 0" v-for="item in benefitOptions" :key="item.Id">
                <td>{{ item.Description }}</td>
                <td v-for="(benefitItem, i) in item.BenefitItems" :key="i">
                  {{ benefitItem.Value }}
                </td>
              </tr>

              <tr v-if="benefitOptions.length == 0">
                <td class="text-center" :colspan="benefitItems.length + 1">{{ noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Benefit option reference for employee -->

    <!-- Form -->
    <form @submit.prevent="save">
      <div class="form-group row align-items-center" v-if="role == 'admin'">
        <label class="col-md-2 mb-0">Employee Name (Emp ID)</label>
        <div class="col-md-7 pl-md-0">
          <Select2
            v-model="userId"
            :options="employees"
            v-if="role == 'admin'"
            required
          />
          <span v-else>{{ employees.length ? employees[0].text : "" }}</span>
        </div>
      </div>

      <div class="form-group row align-items-center" v-if="role == 'admin'">
        <label class="col-md-2 mb-0">Effective Date</label>
        <div class="col-md-7 pl-md-0">
          <input
            type="date"
            class="form-control"
            v-model="effectiveDate"
            required
          />
        </div>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0">New Benefit Option</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="benefitOptionId" required>
            <option value="">-- Please Select --</option>
            <option
              v-for="item in benefitOptions"
              :key="item.Id"
              :value="item.Id"
            >
              {{ item.Description }}
            </option>
          </select>
        </div>
      </div>

      <!-- Disclaimer -->
      <template>
        <div class="form-group row align-items-center mt-5">
          <div class="col-md-1 pr-1" style="max-width: fit-content">
            <input
              type="checkbox"
              style="cursor: pointer"
              required
              v-model="isDisclaimerReadChecked"
            />
          </div>
          <div class="col-md-11 pl-0">
            <label class="mb-0"
              >Click the
              <a :href="backendUrl + '/Docs/Disclaimer.pdf'" target="_blank">
                link
              </a>
              to view and read the Disclaimer and Definition Provisions
            </label>
          </div>
        </div>

        <div class="form-group row align-items-center">
          <div class="col-md-1 pr-1" style="max-width: fit-content">
            <input
              type="checkbox"
              style="cursor: pointer"
              required
              v-model="isDisclaimerAcknowledgeChecked"
            />
          </div>
          <div class="col-md-11 pl-0">
            <label class="mb-0"
              >I acknowledge that I have read and understood the Summary
              Benefits and hereby opt into one of the three options which will
              apply in Calendar Year
              <u
                ><b>{{ disclaimerYear }}</b>
              </u>
            </label>
          </div>
        </div>
      </template>
      <!-- /Disclaimer -->

      <div class="row">
        <div class="col-md-2">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="fa fa-reply mr-2"></i>Back
          </button>
        </div>
        <div class="col-md-7 text-right">
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="
              role == 'employee' &&
              (!isDisclaimerReadChecked || !isDisclaimerAcknowledgeChecked)
            "
          >
            <i v-if="$route.params.id" class="fa fa-save"></i>
            <i v-else class="fa fa-plus"></i>
            {{ $route.params.id ? "Save" : "Add" }}
          </button>
        </div>
      </div>
    </form>
    <!-- Form -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Select2 from "v-select2-component";
export default {
  components: { Select2 },
  data() {
    return {
      employees: [],
      benefitOptions: [],
      disclaimerYear: "",
      noRecordText: config.NO_RECORD_TEXT,
      //form input
      userId: "",
      effectiveDate: "",
      benefitOptionId: "",
      isDisclaimerReadChecked: false,
      isDisclaimerAcknowledgeChecked: false,
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    benefitItems() {
      if (this.benefitOptions && this.benefitOptions.length) {
        return this.benefitOptions[0].BenefitItems;
      } else return [];
    },
    backendUrl() {
      return this.$backendUrl;
    },
  },

  methods: {
    getEmployees() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getBenefitOptions() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getBenefitOptions(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.benefitOptions = response.data.record;
            this.disclaimerYear = response.data.disclaimerYear;
            if (!this.$route.params.id)
              this.effectiveDate = response.data.adminDefaultEffectiveDate;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        UserId: this.role == "admin" ? this.userId : this.employees[0].id,
        EffectiveDateInput: this.effectiveDate,
        BenefitOptionId: this.benefitOptionId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveEmployeeBenefitOption(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.$router.replace({ name: "employeeBenefitOptionList" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getEmployeeBenefitOption() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeBenefitOptionDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) {
              let data = response.data.record;
              this.userId = data.UserId;
              this.effectiveDate = data.EffectiveDate;
              this.benefitOptionId = data.BenefitOptionId;
            } else {
              this.$router.replace({ name: "employeeBenefitOptionList" });
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },

  created() {
    if (this.role == "employee") {
      API.getEnrolmentPeriod({
        Token: this.token,
        Type: "Benefit",
        EmployeeBenefitOptionId: this.$route.params.id,
      })
        .then((response) => {
          if (response.data.success) {
            if (
              !response.data.isEnrolmentOpen ||
              !response.data.isChangeAllowForEmployee
            ) {
              this.$router.replace({ name: "employeeBenefitOptionList" });
              return;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    }

    this.getEmployees();
    this.getBenefitOptions();

    if (this.$route.params.id) this.getEmployeeBenefitOption(); //for edit mode
  },
};
</script>

<style scoped>
[type="checkbox"] {
  margin-top: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/Benefit/EmployeeBenefitOption/EmployeeBenefitOptionEdit.vue